import { api } from '../../lib/api';
import { getLocalDb } from './mapdb';

export async function saveFlashSession(payload) {
  try {
    const { data } = await api.post(`/flash-sessions`, payload);
    return data;
  } catch (e) {
    console.error('saveFlashSession failed', e);
    return null;
  }
}

export async function getFlashSessions() {
  try {
    const { data } = await api.get(`/flash-sessions`);
    return data;
  } catch (e) {
    return [];
  }
}

// ECU records (kode motor). Online: live admin database; offline (EXE): the encrypted Base Map bundle.
export async function getEcuDatabase() {
  try {
    const { data } = await api.get(`/ecu-database`);
    if (Array.isArray(data) && data.length) return data;
  } catch (e) { /* offline → local */ }
  try {
    const d = await getLocalDb();
    return (d && Array.isArray(d.ecu_records)) ? d.ecu_records : [];
  } catch (e) {
    return [];
  }
}
